import React, { useState } from 'react';
import formatDate from '../../utils/formatDate';

export default function CallbackQueue({ callbacks, onDeleteCallback, onBulkDeleteCallbacks }) {
  const [confirmId, setConfirmId] = useState(null);
  const [selected, setSelected] = useState(new Set());
  const [confirmBulk, setConfirmBulk] = useState(false);

  if (!callbacks || callbacks.length === 0) {
    return (
      <div className="card">
        <h3>Callback Queue</h3>
        <p>No callbacks in queue.</p>
      </div>
    );
  }

  const allSelected = callbacks.length > 0 && selected.size === callbacks.length;

  const toggleSelect = (id) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const toggleAll = () => {
    if (allSelected) {
      setSelected(new Set());
    } else {
      setSelected(new Set(callbacks.map((cb) => cb._id)));
    }
  };

  const handleBulkDelete = () => {
    if (confirmBulk) {
      onBulkDeleteCallbacks([...selected]);
      setSelected(new Set());
      setConfirmBulk(false);
    } else {
      setConfirmBulk(true);
    }
  };

  const handleDelete = (id) => {
    if (confirmId === id) {
      onDeleteCallback(id);
      setConfirmId(null);
    } else {
      setConfirmId(id);
    }
  };

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
        <h3 style={{ margin: 0 }}>Callback Queue</h3>
        {selected.size > 0 && (
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <span style={{ fontSize: '0.85rem', color: '#666' }}>{selected.size} selected</span>
            {confirmBulk ? (
              <>
                <button className="btn-danger-sm" onClick={handleBulkDelete}>
                  Delete {selected.size}?
                </button>
                <button className="btn-secondary-sm" onClick={() => setConfirmBulk(false)}>Cancel</button>
              </>
            ) : (
              <button className="btn-danger-sm" onClick={handleBulkDelete}>
                Delete Selected
              </button>
            )}
          </div>
        )}
      </div>
      <table>
        <thead>
          <tr>
            <th style={{ width: '30px' }}>
              <input type="checkbox" checked={allSelected} onChange={toggleAll} />
            </th>
            <th>Call ID</th>
            <th>Phone</th>
            <th>Status</th>
            <th>Confidence</th>
            <th>Created</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {callbacks.map((cb) => (
            <tr key={cb._id} style={{ background: selected.has(cb._id) ? '#edf2f7' : undefined }}>
              <td>
                <input
                  type="checkbox"
                  checked={selected.has(cb._id)}
                  onChange={() => toggleSelect(cb._id)}
                />
              </td>
              <td style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>
                {cb.call_id}
              </td>
              <td>{cb.phone_number}</td>
              <td>
                <span className={`badge badge-${cb.status}`}>
                  {cb.status}
                </span>
              </td>
              <td>{Math.round(cb.confidence * 100)}%</td>
              <td>{formatDate(cb.created_at)}</td>
              <td style={{ whiteSpace: 'nowrap' }}>
                {confirmId === cb._id ? (
                  <>
                    <button className="btn-danger-sm" onClick={() => handleDelete(cb._id)}>Confirm</button>
                    {' '}
                    <button className="btn-secondary-sm" onClick={() => setConfirmId(null)}>Cancel</button>
                  </>
                ) : (
                  <button className="btn-icon" onClick={() => handleDelete(cb._id)} title="Delete">&#128465;</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
